import { render, staticRenderFns } from "./Join1.vue?vue&type=template&id=209f818e&scoped=true&"
import script from "./Join1.vue?vue&type=script&lang=js&"
export * from "./Join1.vue?vue&type=script&lang=js&"
import style0 from "./Join1.vue?vue&type=style&index=0&id=209f818e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f818e",
  null
  
)

export default component.exports